import { PaymentMethod } from '@bybeam/platform-types';
import ClaimRoutes from '@platform-ui/claim/ClaimRoutes.js';

export const getNextPage = (method: Exclude<PaymentMethod, PaymentMethod.External>): string => {
  switch (method) {
    case PaymentMethod.DirectDeposit:
      return ClaimRoutes.ACH_ROUTING_NUMBER;
    case PaymentMethod.Check:
    case PaymentMethod.PhysicalCard:
    case PaymentMethod.VirtualCard:
      return ClaimRoutes.MAILING_ADDRESS;
    case PaymentMethod.Zelle:
      return ClaimRoutes.ZELLE_PRIMER;
    default:
      return ClaimRoutes.ERROR;
  }
};
